// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de Preços')),
  route('create', '/create', Form, professionalMeta('Adicionar Preço')),
  route('edit', '/:id/edit', Form, professionalMeta('Editar Preço'))
]

export default subGroup('/prices', routes)



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/routes.js